import React, { Fragment, useEffect, useState } from 'react';
import { Button, Card, Container, Row, Col, Form, Table, Modal, Tabs, Tab } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import DestinatarioPago from './destinatario-pago';
import { Auth, LoadingComponent } from 'recupero-comunes';
import { dateFormat, formatoMonto, formato_rut, reset_formato_monto } from '../../../../../common/Formatos';
import { serviceGetCasoImplicado, serviceGetCfgForm, serviceGetComboMonedas, serviceGetGestionImplicado, serviceGetPretensionesVigentes, serviceGetInforme } from '../../../../../api/api-confirmar-cierre';
import { FaFilePdf } from "react-icons/fa";


const AddPago = ({ showModal, setShowModal, implicado }) => {
    const { codMonedaLocal, codMonedaConsolida } = Auth.currentUser();
    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const { llaves } = data_encargado;
    const [loading, setLoading] = useState(false);
    const [cfg_form, setCfg_form] = useState(null);
    const [key, setKey] = useState('');
    const [gestionDefenza, setGestionDefenza] = useState(null);
    const [provisionesVigentes, setProvisionesVigentes] = useState([]);
    const [monedas, setMonedas] = useState(null);
    const [involucrado, setInvolucrado] = useState({});
    const [destinatariosPago, setDestinatariosPago] = useState([]);

    const [stateMoneda, setStateMoneda] = useState("");
    const [stateFechaPago, setStateFechaPago] = useState("");
    const [stateComentario, setStateComentario] = useState("");

    const [stateMontoTotal, setStateMontoTotal] = useState(0);
    const [monedaSelected, setMonedaSelected] = useState("");
    const [folioDocumento, setFolioDocumento] = useState(null);
    const [stateDecisionCIA, setStateDecisionCIA] = useState("");
    const [stateComentarioProvision, setStateComentarioProvision] = useState("");

    useEffect(() => {
        if (showModal) { setLoading(true); initialData() };
    }, [showModal])

    useEffect(() => {
        if (gestionDefenza) getProvisionesVigentes();
    }, [gestionDefenza])

    useEffect(() => {
        setMonedaSelected(monedas && monedas.filter(m => Number(m.id) === Number(stateMoneda))[0]?.nombreCorto);
    }, [monedas, stateMoneda])

    useEffect(() => {
        if (provisionesVigentes) initialCalculate();
    }, [provisionesVigentes])

    const initialData = async () => {
        await getCfgForm();
        await getGestionDefenza();
        await getCasoImplicado();
        setLoading(false)
    }

    const getCfgForm = async () => {
        const query = Buffer.from(JSON.stringify({ rutcia: llaves.idOrgCaso, idform: 48 })).toString('base64');
        const response = await serviceGetCfgForm(query);

        setCfg_form(response);
    }

    const getGestionDefenza = async () => {
        const query_one = Buffer.from(JSON.stringify({ idCaso: llaves.idCaso, idImplicado: implicado })).toString('base64');
        const response_one = await serviceGetGestionImplicado(query_one);

        const paisOrganizacion = Auth.currentUser().paisOrganizacion;
        const codClasCaso = response_one && response_one.length > 0 && response_one[0].codClasCaso;
        const query_two = Buffer.from(JSON.stringify({ pais: paisOrganizacion, clasBien: codClasCaso })).toString('base64');

        const response_two = await serviceGetComboMonedas(query_two);
        setMonedas(response_two);
        setGestionDefenza(response_one[0]);
    }

    const getProvisionesVigentes = async () => {
        let query = Buffer.from(JSON.stringify({
            idCaso: llaves.idCaso,
            idImplicado: implicado,
            tipoGestion: gestionDefenza.codTipoGestion,
            tipoMovimiento: 261004,
            situacion: "245002",
        })).toString('base64')

        const response = await serviceGetPretensionesVigentes(query);

        if (response?.coberturasPoliza) {
            setProvisionesVigentes(
                response?.coberturasPoliza
                    .filter(c => c.actualizaMonto === "S" && Number(c.montoPretencion) > 0)
                    .map(c => ({
                        ...c,
                        montoPretencion: formatoMonto(c.montoPretencion)
                    }))
            )
        }

        //setProvisionesVigentes(response);
    }

    const getCasoImplicado = async () => {
        let query = Buffer.from(JSON.stringify({ idCaso: llaves.idCaso, idImplicado: implicado })).toString('base64');
        const response = await serviceGetCasoImplicado(query);

        const result = response[0]?.ultimoPagoIndemnizar;
        setStateMoneda(response && result?.CodMonedaIngreso ? result?.CodMonedaIngreso : "");
        setStateComentario(response && result?.Comentario ? result?.Comentario : "");
        setStateFechaPago(response && result?.FechaActualizacionFormat ? dateFormat(result?.FechaActualizacionFormat) : "");
        setFolioDocumento(result?.FolioDocumento || null);

        const ultimaProvision = response[0]?.ultimaProvision;
        setStateDecisionCIA(ultimaProvision?.GlosaDecisionCIA || "");
        setStateComentarioProvision(ultimaProvision?.Comentario || "");

        setInvolucrado({
            id: response[0]?.IdImplicado,
            rut: response[0]?.RutInvolucrado,
            nombre: response[0]?.NombreInvolucrado,
            tipo: response[0]?.GlosaTipoInvolucrado,
            patente: response[0]?.Patente,
            lesionado: response[0]?.GlosaImplLesionado,
        })

        setDestinatariosPago(response[0]?.destinatariosPago || [])
    }

    const handleSelect = (k) => {
        setKey(k);
        if (k === key) setKey("");
    }

    const initialCalculate = () => {
        let total = 0;
        provisionesVigentes?.forEach(pre => {
            total += Number(reset_formato_monto(pre.montoPretencion));
        })
        setStateMontoTotal(formatoMonto(total));
    }

    const validateMonto = (data) => {
        data.forEach(value => { if (value.montoPretencion) return true; })
        return false;
    }

    const handleShowContrato = async () => {
        if (!folioDocumento) return;
        setLoading(true);
        const query = Buffer.from(JSON.stringify({ idCaso: String(llaves.idCaso), idImplicadoCaso: String(implicado), idCompania: String(llaves.idOrgCaso), idfolioCarga: folioDocumento })).toString('base64');
        const response = await serviceGetInforme(query);
        setLoading(false);
        const blob = new Blob(
            [Uint8Array.from(atob(response.file), c => c.charCodeAt(0))],
            { type: response.mimetype || 'application/pdf' }
        );
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.download = response.filename;
        link.href = url;
        link.click();
        URL.revokeObjectURL(url);
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setStateMoneda("");
        setStateFechaPago("");
        setStateComentario("");
        setKey("");
        setFolioDocumento(null);
        setStateDecisionCIA("");
        setStateComentarioProvision("");
    }

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Modal show={showModal} onHide={setShowModal} size='xl'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                        {cfg_form && cfg_form["modalpagoindemnizar-title-modal"]}
                    </Card.Header>

                    <Card.Body>
                        <Container className='mb-4'>
                            <Row>
                                <Col md='2'>
                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                        {cfg_form && cfg_form["modalpagoindemnizar-lbl-rut"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Text className='mb-3'>
                                        {involucrado.rut && formato_rut(involucrado.rut)}
                                    </Form.Text>
                                </Col>
                                <Col md='3'>
                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                        {cfg_form && cfg_form["modalpagoindemnizar-lbl-nombre"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Text className='mb-3'>
                                        {involucrado.nombre && involucrado.nombre}
                                    </Form.Text>
                                </Col>
                                <Col md='3'>
                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                        {cfg_form && cfg_form["modalpagoindemnizar-lbl-tipoinvol"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Text className='mb-3'>
                                        {involucrado.tipo && involucrado.tipo}
                                    </Form.Text>
                                </Col>
                                <Col md='2'>
                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                        {cfg_form && cfg_form["modalpagoindemnizar-lbl-patente"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Text className='mb-3'>
                                        {involucrado.patente && involucrado.patente}
                                    </Form.Text>
                                </Col>
                                <Col md='2'>
                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                        {cfg_form && cfg_form["modalpagoindemnizar-lbl-impllesio"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Text className='mb-3'>
                                        {involucrado.lesionado && involucrado.lesionado}
                                    </Form.Text>
                                </Col>
                            </Row>
                        </Container>

                        <Container className='mb-4'>
                            <Row>
                                <Col md='4'>
                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                        {cfg_form && cfg_form["modalpagoindemnizar-lbl-decisioncia"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Text className='mb-3'>
                                        {stateDecisionCIA}
                                    </Form.Text>
                                </Col>
                                <Col md='8'>
                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                        {cfg_form && cfg_form["modalpagoindemnizar-lbl-comentariosprov"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Text className='mb-3'>
                                        {stateComentarioProvision}
                                    </Form.Text>
                                </Col>
                            </Row>
                        </Container>

                        <Container className='mb-4'>
                            <Tabs className='nav-tabs' id='uncontrolled-tab-example' activeKey={key} onSelect={(k) => handleSelect(k)}>
                                <Tab.Pane eventKey="destinatario" title="Destinatario de Pago">
                                    <DestinatarioPago cfg_form={cfg_form} destinatariosPago={destinatariosPago} />
                                </Tab.Pane>
                            </Tabs>

                            <Row className='form mt-3'>
                                <Col md='3'>
                                    <Form.Label className="label">
                                        {cfg_form && cfg_form["modalpagoindemnizar-cmb-moneda"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Select
                                        readOnly
                                        name='codMonedaIngreso'
                                        value={stateMoneda}>

                                        <option value={''}>Seleccione...</option>
                                        {monedas && monedas
                                            .filter(m => m.id === Number(codMonedaLocal) || m.id === Number(codMonedaConsolida))
                                            .map((c) => (<option key={c.id} value={c.id}>{c.nombre}</option>))
                                        }
                                    </Form.Select>
                                </Col>
                                <Col md='3'>
                                    <Form.Label className="label">
                                        {cfg_form && cfg_form["modalpagoindemnizar-cmb-fechapago"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Control
                                        readOnly
                                        type="date"
                                        name='fechaActualizacion'
                                        value={stateFechaPago}>
                                    </Form.Control>
                                </Col>
                                <Col md='4'>
                                    <Form.Label className="label">
                                        {cfg_form && cfg_form["modalpagoindemnizar-input-comentario"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Control
                                        readOnly
                                        name='comentario'
                                        value={stateComentario}>
                                    </Form.Control>
                                </Col>
                                <Col md='2' className='text-center'>
                                    <Form.Label className="label">
                                        {cfg_form && cfg_form["modalpagoindemnizar-lbl-contrato"]}
                                    </Form.Label>
                                    <br />
                                    <FaFilePdf
                                        size={28}
                                        color={folioDocumento ? '#dc3545' : '#adb5bd'}
                                        title={folioDocumento ? "Ver Contrato Transacción" : "Sin documento"}
                                        style={{ cursor: folioDocumento ? 'pointer' : 'default', marginTop: '4px' }}
                                        onClick={handleShowContrato}
                                    />
                                </Col>
                            </Row>
                        </Container>

                        <Container>
                            <div className="container_table">
                                <div className="container_table_header">
                                    {cfg_form && cfg_form["modalpagoindemnizar-grilla-vig"]}
                                </div>
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>{cfg_form && cfg_form["modalpagoindemnizar-grilla-cobertura"]}</th>
                                            <th>{cfg_form && cfg_form["modalpagoindemnizar-grilla-monto"]} {monedaSelected ? `(${monedaSelected})` : ""}</th>
                                            <th>{cfg_form && cfg_form["modalpagoindemnizar-grilla-estado"]}</th>
                                            <th>{cfg_form && cfg_form["modalpagoindemnizar-grilla-fecharegistro"]}</th>
                                            <th>{cfg_form && cfg_form["modalpagoindemnizar-grilla-montopago"]}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {provisionesVigentes && provisionesVigentes?.map((pre, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{pre.cobertura}</td>
                                                    <td><strong>{pre.montoPretencion}</strong></td>
                                                    <td>{pre.glosaEstado}</td>
                                                    <td>{pre.fechaRegistroFmt}</td>
                                                    <td>
                                                        <Form.Control
                                                            readOnly
                                                            value={pre.montoPretencion}
                                                            style={{ backgroundColor: '#e9ecef' }}
                                                        />
                                                    </td>
                                                </tr>
                                            )
                                        })
                                        }
                                        <tr>
                                            <td><strong>{cfg_form && cfg_form["modalpagoindemnizar-lbl-total"]}</strong></td>
                                            <td><strong>{stateMontoTotal} {monedaSelected ? `(${monedaSelected})` : ""}</strong></td>
                                            <td></td>
                                            <td></td>
                                            <td><strong>{stateMontoTotal} {monedaSelected ? `(${monedaSelected})` : ""}</strong></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </Container>
                    </Card.Body>

                    <Card.Footer style={{ display: 'flex', justifyContent: 'right', gap: '8px' }}>
                        <Button className='w-auto' variant='outline-info' onClick={handleCloseModal}>
                            {cfg_form && cfg_form["modalpagoindemnizar-btn-volver"]}
                        </Button>
                    </Card.Footer>
                </Card>
            </Modal>

            <style type='text/css'>
                {`
                    .container_table_header {
                        padding: 10px 20px;
                        background-color: #716e9e;
                        border-top-left-radius: 5px;
                        border-top-right-radius: 5px;
                        color: white
                    }
                    .label {
                        font-weight: bold;
                        font-size: 14px;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default AddPago;